import { createContext } from 'react';

import { GAUGE_DEFAULT_CONFIG } from '../constants.js';
import type { GaugeChartConsumerConfig } from '../types/gauge-chart-config.js';

/**
 * @internal
 */
export const GaugeChartConfigContext = createContext<
  GaugeChartConsumerConfig | string
>(GAUGE_DEFAULT_CONFIG);

/**
 * Provider for the gauge chart configuration that can be shared across charts
 * @public
 */
export const GaugeChartConfig = GaugeChartConfigContext.Provider;
